import React from 'react';
import { motion } from 'framer-motion';
import { useCountUp, useInView } from '@/lib/hooks';
import { STATS } from '@/constants/testIds';

function StatItem({ value, suffix = '', label, special = false }) {
  const isNum = typeof value === 'number';
  const [ref, count, inView] = useCountUp(isNum ? value : 0, { duration: 1400 });
  const display = isNum ? `${count}${suffix}` : value;
  return (
    <div ref={ref} className="flex-1 text-center px-4 py-7">
      <motion.div
        className={`font-display font-semibold text-[2.6rem] md:text-[3rem] leading-none tracking-tight ${special ? 'text-[color:var(--sh-amber-2)]' : 'text-[color:var(--sh-ink)]'}`}
        initial={{ opacity: 0, y: 10 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.5 }}
      >
        {display}
      </motion.div>
      <div className="mt-3 text-[11px] font-accent tracking-[0.22em] uppercase text-[color:var(--sh-muted)]">
        {label}
      </div>
    </div>
  );
}

function VerticalHexDiv({ inView, delay }) {
  return (
    <div className="hidden md:flex items-center" aria-hidden>
      <svg width="14" height="30" viewBox="0 0 14 30">
        <motion.polygon
          points="7,2 12,7 12,23 7,28 2,23 2,7"
          fill="none"
          stroke="#E8E6DF"
          strokeWidth="1"
          initial={{ pathLength: 0, opacity: 0 }}
          animate={inView ? { pathLength: 1, opacity: 1 } : {}}
          transition={{ duration: 0.7, delay }}
        />
      </svg>
    </div>
  );
}

export default function Stats() {
  const [ref, inView] = useInView({ threshold: 0.4, once: true });
  return (
    <section id="stats" ref={ref} className="px-4 md:px-8 -mt-6 md:-mt-10 relative z-20" data-testid={STATS.block}>
      <div className="max-w-5xl mx-auto rounded-2xl bg-white border border-[color:var(--sh-line)] shadow-[0_18px_50px_-24px_rgba(15,26,51,0.18)]">
        <div className="flex flex-col md:flex-row items-stretch md:items-center divide-y md:divide-y-0 divide-[color:var(--sh-line-2)]">
          <StatItem value={24} suffix="hr" label="Proposal Turnaround" />
          <VerticalHexDiv inView={inView} delay={0.1} />
          <StatItem value={5} suffix=" Days" label="Average Launch Time" />
          <VerticalHexDiv inView={inView} delay={0.2} />
          <StatItem value={100} suffix="%" label="On-Time Delivery" />
          <VerticalHexDiv inView={inView} delay={0.3} />
          <StatItem value="∞" label="Coffee Consumed" special />
        </div>
      </div>
    </section>
  );
}
